import React from 'react';
import { Container, Section } from '../ui/Section';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleBurst, DoodleCircle, DoodleHeart } from '../brand/Doodles';
type Fact = {
  label: string;
  title: string;
  copy: string;
  doodle: React.ReactNode;
  accent: string;
};
const facts: Fact[] = [{
  label: 'When',
  title: 'Thursday Nights',
  copy: 'Worship begins at 7:30 PM during the school year.',
  doodle: <DoodleBurst className="h-10 w-10" color="var(--bcm-dark-blue)" data-id="element-225" data-mp="2i9kmjjkegq3n" />,
  accent: 'bg-brand-yellow'
}, {
  label: 'Where',
  title: 'UCF Student Union',
  copy: 'Most weeks, find BCM on the third floor in Cape Florida Ballroom, Room 316.',
  doodle: <DoodleCircle className="h-10 w-16" color="var(--bcm-dark-blue)" data-id="element-226" data-mp="2n9p6xkofi4z5" />,
  accent: 'bg-brand-blue'
}, {
  label: 'Who',
  title: 'Everyone Is Welcome',
  copy: 'You do not have to be Baptist—or even Christian—to attend.',
  doodle: <DoodleHeart className="h-10 w-10" color="var(--bcm-dark-blue)" data-id="element-227" data-mp="sxsafdb4q8x8" />,
  accent: 'bg-brand-pink'
}];
export function QuickFacts() {
  return <Section className="bg-[#fffdf6] py-16 sm:py-20" labelledBy="quick-facts-heading" data-id="element-228" data-mp="3okxn2xky4s3v">
      <Container data-id="element-229" data-mp="3tkabhmrgu78k">
        <Reveal data-id="element-230" data-mp="3tjs4pw76game">
          <h2 id="quick-facts-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-231" data-mp="3tj8xpaj2f6n5">
            Your first visit, at a glance
          </h2>
        </Reveal>

        <ul className="mt-9 grid gap-5 sm:grid-cols-3" data-id="element-232" data-mp="76tnlwvwishh">
          {facts.map((fact, index) => <Reveal key={fact.label} as="li" delay={stagger(index)} className="relative flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-6 transition-transform duration-200 hover:-translate-y-1" data-id="element-233" data-mp="c5wtfjjph2qi" data-mpi={index}>
              <span className={`absolute -top-3 left-6 rounded-full px-3 py-1 font-meta text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy ${fact.accent}`} data-id="element-234" data-mp="2hylb3djg81dc">
                {fact.label}
              </span>
              <div className="mt-3" aria-hidden="true" data-id="element-235" data-mp="3l8g05i2vwozi">
                {fact.doodle}
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-brand-navy sm:text-2xl" data-id="element-236" data-mp="334d3r1xuhh1">
                {fact.title}
              </h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-237" data-mp="3uagxeey4bb16">{fact.copy}</p>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}